import { t } from "@/i18n-js/instance";
import { useExportCsvModal } from "@circle-react-shared/Paywalls/Modals/ExportCsvModal";
import { Button } from "@circle-react-shared/uikit/Button";
import "./";

export const HeaderRightContent = ({ totalSubscriptionsCount }: any) => {
  const { show } = useExportCsvModal();

  const showExportModal = () => {
    void show({ relation: "subscriptions" });
  };

  const shouldDisableButton = totalSubscriptionsCount <= 0;

  return (
    <Button
      variant="circle"
      onClick={showExportModal}
      type="button"
      disabled={shouldDisableButton}
    >
      {t("export_paywall_csv.modal.export_cta")}
    </Button>
  );
};
